import { InjectionToken } from '@angular/core';
import { SearchProvider } from '../models/search-provider.model';

/**
 * Multi-provider token. Each domain module registers its SearchProvider
 * through this token in app.config.ts. The IntelligentSearchService injects
 * all registered providers at construction time.
 *
 * Example:
 *   providers: [
 *     { provide: SEARCH_PROVIDER, useExisting: SettingsSearchProvider, multi: true },
 *     { provide: SEARCH_PROVIDER, useExisting: PermissionsSearchProvider, multi: true },
 *   ]
 */
export const SEARCH_PROVIDER = new InjectionToken<SearchProvider<unknown>>(
  'SEARCH_PROVIDER'
);
